import Settings from './settings'

export default {
  ...Settings,
  urlHotFolder: 'https://hotfolder.idoccar.com/api/',
  webSocketUrl: 'wss://qa.idoccar.com:8010',
  // url: 'https://prepropenske.idoccar.com/api/',
  url: 'https://test-vgrs.idoccar.com/api/',
  // url: 'https://qa-vgrs.idoccar.com/api/',
  // url: 'https://preprovgrs.idoccar.com/api/',
  // url: 'https://test-toyota.idoccar.com/api/',
  // url: 'https://qa-toyota.idoccar.com/api/',
  /// url: 'https://preprotoyota.idoccar.com/api/',
  // url: 'https://preprodemo.idoccar.com/api/',
  // url: 'https://qa.idoccar.com/api/',
  notificationRefresh: 60000,
  showSignDocumentButton: false,
  acceptFileFormats: 'application/pdf, .jpg, .png, .jpeg, .gif, .docx, .doc, .xls, .xlsx, .ppt, .pptx, .msg, .tiff',
  qaSite: true,
  dealerMaxLength: 6,
  dealerNumberRegex: null,
  // clientFieldValidation: 'demo',
  clientFieldValidation: 'vgr',
  autoLoadDashboard: true,
  validateLicensePlate: true,
  maxTagCount: 2,
  maxTagTextLength: 10,
  matomoSiteId: '17',
  authenticationWithSalt: false,
  enableFavoritesAndRecents: true,
  enableTaskFollowUp: true,
  dashboardVersion: 2,
  usersManualUrl: 'https://toyota-formacion-new.idoccar.com',
  usersManualEnvironment: 'qa',
  showV2Link: true,
  environmentName: 'test-VGRS'
  // environmentName: 'pre-VGRS'
  // environmentName: 'qa-VGRS'
  // environmentName: 'test-TOYOTA'
  // environmentName: 'qa-TOYOTA'
  // environmentName: 'pre-TOYOTA'
  // environmentName: 'pre-DEMO'
}
